import { INFO_MODULE_VIEWS } from "config/userPermissions";
import { Route } from "react-router-dom";
import { VIEWS } from "./constants";

export const getRoutes = (modulesOfCurrentUser) => {
    const filterViews = INFO_MODULE_VIEWS
        // Filtrando solo los módulos que puede acceder el usuario actual
        .filter(({ id }) => modulesOfCurrentUser.includes(id))
        // Ensamblando Route para la vista
        .map(({ id, path }, idx) => {
            return (
                <Route 
                    key={idx}
                    path={`${path}/*`} 
                    element={VIEWS[id]}/>
            );
        });
    return filterViews;
};